import { useEffect } from "react";
import { Container, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";
import useStyles from "./styles";

function ErrorPage() {
  const classes = useStyles();

  useEffect(() => {
    document.title = "404 - Error";
  }, []);

  return (
    <Container maxWidth={false} className={classes.pageContainer}>
      <Typography variant="h1" className={classes.headerText}>
        404
      </Typography>
      <Typography variant="subtitle1" className={classes.contentText}>
        Looks like the page you're looking for doesn't exist. Press{" "}
        <Link className={classes.link} to="/">
          here
        </Link>{" "}
        to return to the main page.
      </Typography>
    </Container>
  );
}

export default ErrorPage;
